var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7247 4.55806C10.4806 4.80214 10.4806 5.19786 10.7247 5.44194L14.6578 9.375H5.75C5.40482 9.375 5.125 9.65482 5.125 10C5.125 10.3452 5.40482 10.625 5.75 10.625H14.6578L10.7247 14.5581C10.4806 14.8021 10.4806 15.1979 10.7247 15.4419C10.9688 15.686 11.3645 15.686 11.6086 15.4419L16.6086 10.4419C16.8527 10.1979 16.8527 9.80214 16.6086 9.55806L11.6086 4.55806C11.3645 4.31398 10.9688 4.31398 10.7247 4.55806Z",
    fill: "#656579"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlack);
export default __webpack_public_path__ + "static/media/arrow-right-black.5366379abbdafc45e12cece2fea1c9b4.svg";
export { ForwardRef as ReactComponent };